import React from 'react';
import FamilyLinksTabComponent from '../../../../../components/Locations/FamilyLinksTab';
import { getLocationId } from '../../../utils/locationTransformers';

const FamilyLinksTab = ({ selectedLocation }) => (
  <FamilyLinksTabComponent locationId={getLocationId(selectedLocation)} />
);

export default FamilyLinksTab;
